import { useContext } from "react";
import { Web3AuthContext } from "../contexts/Web3AuthContext";

export const useWeb3Auth = () => {
  const {
    login,
    loginAsGuest,
    logout,
    switchChain,
    logined,
    connectedAdapterName,
    provider,
    address,
    proticoAuthenticate,
    proticoGoogleAuthenticate,
    isProticoAuthenticated,
    isInited,
    userInfo,
    realAddress,
    currentToken,
  } = useContext(Web3AuthContext);
  return {
    login,
    loginAsGuest,
    logout,
    switchChain,
    logined,
    connectedAdapterName,
    provider,
    address,
    proticoAuthenticate,
    proticoGoogleAuthenticate,
    isProticoAuthenticated,
    isInited,
    userInfo,
    realAddress,
    currentToken,
  };
};
